/* eslint-disable @typescript-eslint/naming-convention */

export enum SafetyHintType {
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
}

export interface SafetyHint {
    type: SafetyHintType;
    title: string;
    content: string;
}

export interface Etag {
    $oid: string;
}

export interface RhDoc {
    _id: string;
    fs_date: any;
    fs_project_id: number;
    fs_project_name: string;
    fs_revision_id: number;
    type: string;
    title: string;
    content: string;
    fs_reference_name: string;
    fs_object_type: string;
    fs_uid_type: string;
    fs_scheduler_date: any;
    headline: string;
    fs_id: string;
    fs_language: string;
    _etag: Etag;
}

export interface Embedded {
    'rh:doc': RhDoc[];
}

export interface SafetyHintResponse {
    _id: string;
    _etag: Etag;
    _returned: number;
    _embedded: Embedded;
}
